export function extractPhoneNumber(value: string): string {
// eslint-disable-next-line no-useless-escape
  const phoneRegex = /^\(?\d{3}\)?[-.\s]?\d{3}[-.\s]?\d{4}$/;

  if (phoneRegex.test(value)) {
      const cleanedNumber = value.replace(/\D/g, '');
      return cleanedNumber;
  }

  return value;
}


export const getPayloadObjectForDoNotSell = (payloadParams) => {
  const customerData = payloadParams.customer
  let payload = {
  requestType: 'DO_NOT_SELL',
  email:'',
  phoneNumber:'',
  uuid: '',
  action: payloadParams.action.DONOTSELL,
  attributes: {
    customerAgentInfo: {
      customer: customerData
    }
  }
 };
  if(phoneRegex.test(customerData.emailPhone)) {
     customerData.phoneNumber=customerData.emailPhone.match(/\d+/g).join('')
      payload.phoneNumber=  customerData.phoneNumber
      delete payload.email
  }
  else{
    customerData.email = customerData.emailPhone
      payload.email = payloadParams.customer.emailPhone
      delete payload.phoneNumber
   }
  return payload;
};

// eslint-disable-next-line no-useless-escape
export const emailRegex = /^((?!^\.)(?!.*\.{2})([\w!#$%&'*+\-\/=?\^`.{|}~]*)[^.\s<>(),:;"@[\]])@(([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,})$/i;
// eslint-disable-next-line no-useless-escape
export const phoneRegex = /^(1\s|1|)?((\(\d{3}\))|\d{3})(\-|\s)?(\d{3})(\-|\s)?(\d{4})$/;
